import React from 'react'

const Panel = ({ id, current, showContent, children }) =>
  <div
    className={`bg-white min-vh-100 panel ${
      id == current.slice(1) ? 'panel-active' : ''
    }`}
    id={id}
  >
    <div className="panel-inner">
      {children}
    </div>
  </div>

export default Panel
